module.exports = "pegasus/assets/theme6/small/1.jpg";